module.exports = __webpack_public_path__ + "static/7-5582d41f63010183d73b65b3752a74e9.jpg";